import { createSlice } from '@reduxjs/toolkit'
import { strapiFetch, StrapiApiError } from '../../api/strapi'

const slice = createSlice({
    name: 'contact',
    initialState: {
        data: null,
        loading: false,
        loaded: false,
        error: null,
        submitLoading: false,
        submitError: null,
    },
    reducers: {
        setLoading: (state, action) => { state.loading = action.payload },
        setLoaded: (state, action) => { state.loaded = action.payload },
        setData: (state, action) => { state.data = action.payload },
        setError: (state, action) => { state.error = action.payload },
        setSubmitLoading: (state, action) => { state.submitLoading = action.payload },
        setSubmitError: (state, action) => { state.submitError = action.payload },
    },
})

export default slice.reducer

export const {
    setLoading,
    setLoaded,
    setData,
    setError,
    setSubmitLoading,
    setSubmitError,
} = slice.actions

export const loadContactPageData = (locale) => async dispatch => {
    dispatch(setLoading(true))
    dispatch(setError(null))
    dispatch(setData(null))
    try {
        const json = await strapiFetch('/api/contact-page', {
            locale,
            params: {
                'populate[seo]': 'true',
                'populate[banner][populate][bannerImage]': 'true',
            },
        })
        dispatch(setData(json.data))
        dispatch(setLoaded(true))
    } catch (e) {
        dispatch(setError(e instanceof StrapiApiError ? e.message : 'Failed to load contact page'))
    } finally {
        dispatch(setLoading(false))
    }
}

// Keeps the ContactUs contract: payload { name, phone, email, subject, message, token, locale }
export const sendContactUsData = (payload) => async dispatch => {
    dispatch(setSubmitLoading(true))
    dispatch(setSubmitError(null))
    try {
        const json = await strapiFetch('/api/contact-submissions', {
            method: 'POST',
            body: JSON.stringify({
                data: {
                    name: payload.name,
                    email: payload.email,
                    phone: payload.phone || null,
                    subject: payload.subject,
                    message: payload.message,
                    locale: payload.locale || 'en',
                    turnstileToken: payload.token,
                },
            }),
        })
        return json
    } catch (e) {
        dispatch(setSubmitError(e instanceof StrapiApiError ? e.message : 'Failed to send contact form'))
        throw e
    } finally {
        dispatch(setSubmitLoading(false))
    }
}
